// ModalHeader.tsx
import React, { useContext } from "react";
import { ModalVariantContext } from "../../ModalContext";
import CloseIcon from "../../../Icons/CloseIcon";

interface ModalHeaderProps {
  children: React.ReactNode;
  onClose?: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ children, onClose }) => {
  const variant = useContext(ModalVariantContext);

  const variantClasses = {
    neutral: {
      border: "border-indigo-700",
      text: "text-white",
      background: 'bg-indigo-900',
    },
    warning: {
      border: "border-cherry-400",
      text: "text-indigo-1000",
      background: 'bg-indigo-900',
    },
    dark: {
      border: "border-indigo-700",
      text: "text-white",
      background: 'bg-indigo-900',
    },
  };

  return (
    <div
      className={`flex justify-between items-center py-3 px-4 border-b max-sm:sticky max-sm:top-0 z-10
        ${variantClasses[variant].border} ${variantClasses[variant].text} ${variantClasses[variant].background} `}
    >
      <div style={{ fontSize: "18px", lineHeight: "28px", fontWeight: 500, color: "var(--color-gray-100)" }}
           className="w-full items-center">
        {children}
      </div>
      {onClose && (
        <CloseIcon aria-label="Close" className="h-10 w-10 rounded-full p-2 hover:bg-indigo-700 cursor-pointer text-white!"
             onClick={onClose}/>
      )}
    </div>
  );
};

export default ModalHeader;
